const conf = {
  url: {
    mapJs: `https://sdk.woosmap.com/map/map.js?key=${process.env.GATSBY_WOOSMAP_API_KEY}`,
  },
  search: {
    inputId: 'woosmap-searchbox',
  },
  woosmapConfig: {
    zoom: 14,
    disableTilt: false,
    disableDefaultUI: false,
    // gestureHandling: 'greedy',
    // styles: [
    //   {
    //     elementType: 'geometry',
    //     stylers: [{ color: '#f2f5f7' }],
    //   },
    //   {
    //     elementType: 'labels.icon',
    //     stylers: [{ visibility: 'off' }],
    //   },
    //   {
    //     elementType: 'labels.text.fill',
    //     stylers: [{ color: '#818d9b' }],
    //   },
    //   {
    //     elementType: 'labels.text.stroke',
    //     stylers: [{ color: '#f5f5f5' }],
    //   },
    //   {
    //     featureType: 'administrative.land_parcel',
    //     elementType: 'labels.text.fill',
    //     stylers: [{ color: '#bdbdbd' }],
    //   },
    //   {
    //     featureType: 'road',
    //     elementType: 'geometry',
    //     stylers: [{ color: '#ffffff' }],
    //   },
    //   {
    //     featureType: 'road.arterial',
    //     elementType: 'labels.text.fill',
    //     stylers: [{ color: '#939bb7', weight: 100 }],
    //   },
    //   {
    //     featureType: 'road.highway',
    //     elementType: 'geometry',
    //     stylers: [{ color: '#dadada' }],
    //   },
    //   {
    //     featureType: 'road.highway',
    //     elementType: 'labels.text.fill',
    //     stylers: [{ color: '#9aa8b9' }],
    //   },
    //   {
    //     featureType: 'road.local',
    //     elementType: 'labels.text.fill',
    //     stylers: [{ color: '#939bb7' }],
    //   },
    //   {
    //     featureType: 'transit.line',
    //     elementType: 'geometry',
    //     stylers: [{ color: '#e5e5e5' }],
    //   },
    //   {
    //     featureType: 'transit.station',
    //     elementType: 'geometry',
    //     stylers: [{ color: '#eeeeee' }],
    //   },
    //   {
    //     featureType: 'water',
    //     elementType: 'geometry',
    //     stylers: [{ color: '#cadce9', saturation: 30 }],
    //   },
    //   {
    //     featureType: 'water',
    //     elementType: 'labels.text.fill',
    //     stylers: [{ color: '#9e9e9e' }],
    //   },
    //   {
    //     featureType: 'poi',
    //     elementType: 'labels.text.fill',
    //     stylers: [{ color: '#9aa8b9' }],
    //   },
    //   {
    //     featureType: 'poi.park',
    //     elementType: 'geometry',
    //     stylers: [{ color: '#71bdb1', saturation: 20 }],
    //   },
    //   {
    //     featureType: 'poi.park',
    //     elementType: 'labels.text.fill',
    //     stylers: [{ color: '#9aa8b9' }],
    //   },
    // ],
  },
  zoomControls: true,
  fullView: false,
  hideMarkers: false,
  infoWindows: false,
  mapPaddings: {
    mobile: { left: 50, right: 50, top: 125, bottom: 200 },
    full: { left: 550, right: 50, top: 200, bottom: 100 },
  },
};

export function mergeDefaults(config, defaults) {
  if (config === null || config === undefined) return defaults;
  for (let attrname in defaults)
    if (defaults[attrname].constructor === Object)
      config[attrname] = mergeDefaults(config[attrname], defaults[attrname]);
    else if (config[attrname] === undefined) config[attrname] = defaults[attrname];
  return config;
}

export default conf;
